import service from '@/store/services/facturas-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  listGlobal: {},
  listActive: {},
  factura: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_LIST_GLOBAL: (state, list) => {
    state.listGlobal = list;
  },
  SET_LIST_ACTIVE: (state, listActive) => {
    state.listActive = listActive;
  },
  SET_RESOURCE: (state, factura) => {
    state.factura = factura;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  listGlobal({commit, dispatch}, params = {}) {
    return service.listGlobal(params, this.$axios)
      .then(({listGlobal, meta}) => {
        commit('SET_LIST_GLOBAL', listGlobal);
        commit('SET_META', meta);
      });
  },

  listActive({ commit, dispatch }, params) {
    return service.listActive(params).then(({ listActive }) => {
      commit("SET_LIST_ACTIVE", listActive);
    });
  },

  getRegimenes({commit, dispatch}, params) {
    return service.getRegimenes(params, this.$axios)
      .then((factura) => { commit('SET_RESOURCE', factura); });
  },

  add({commit, dispatch}, params) {
    return service.add(params, this.$axios)
      .then((factura) => { commit('SET_RESOURCE', factura); });
  },

  addGlobal({commit, dispatch}, params) {
    return service.addGlobal(params, this.$axios)
      .then((factura) => { commit('SET_RESOURCE', factura); });
  },

  getCliente({commit, dispatch}, params) {
    return service.getCliente(params, this.$axios)
      .then((factura) => { commit('SET_RESOURCE', factura); });
  },
  getFactura({ commit, dispatch }, factura) {
    return service.getFactura(factura, this.$axios);
  },
  getFacturaGlobal({ commit, dispatch }, factura) {
    return service.getFacturaGlobal(factura, this.$axios);
  },
  
};

const getters = {
  list: state => state.list,
  listGlobal: state => state.listGlobal,
  listActive: state => state.listActive,
  listTotal: state => state.meta.total,
  listTotalGlobal: state => state.meta.total, 
  factura: state => state.factura,
  getRegimenes: state => state.factura,
  getCliente: state => state.factura,
  url: state => state.url
};

const facturas = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default facturas;
